import { GLOBAL_LOADER_SET } from '../action-types/global-loader.action-types';

export type GlobalLoaderType = 'standard' | 'with-delay';

export type GlobalLoaderReducer = {
  showGlobalLoader: boolean;
  globalLoaderType: GlobalLoaderType;
};

const initialState: GlobalLoaderReducer = {
  showGlobalLoader: false,
  globalLoaderType: 'standard',
};

const globalLoaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GLOBAL_LOADER_SET: {
      return {
        ...state,
        showGlobalLoader: action.showGlobalLoader,
        globalLoaderType: action.globalLoaderType || 'standard',
      };
    }
    default: {
      return state;
    }
  }
};

export default globalLoaderReducer;
